import $ from 'jquery';

const $body = $('body');

// because some containers have a transform applied to them
// (due to a will-change: transform), we need to put all our fixed
// elements (such as dialogs) in the body so that their position
// keeps being relative to the viewport and not the content-container
// see https://www.w3.org/TR/css-transforms-1/#propdef-transform
export default {
  inserted(el) {
    $(el).appendTo($body);
  },
};
